// extracted by mini-css-extract-plugin
export default {"creditProgress":"credit-progress_creditProgress__AxtQh","disclaimer":"credit-progress_disclaimer__6lUvy"};